import type { ImageTextV1Content } from '@/core/types';

import { ImageTextV1 } from '@/containers/blocks/image-text';

export default function generate({
  content,
  className,
}: {
  content: ImageTextV1Content;
  className?: string;
}) {
  return (
    <ImageTextV1
      title={content.title}
      titleTag={content.titleTag}
      description={content.description}
      image={content.image}
      buttons={content.buttons}
      className={className}
    />
  );
}
